import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shop",
  "use": "icon-shop-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 48 48\" fill=\"none\" id=\"icon-shop\"><rect width=\"48\" height=\"48\" fill=\"white\" fill-opacity=\"0.01\" /><path d=\"M4 12H44V20L42.6015 20.8391C40.3847 22.1692 37.6153 22.1692 35.3985 20.8391L34 20L32.6015 20.8391C30.3847 22.1692 27.6153 22.1692 25.3985 20.8391L24 20L22.6015 20.8391C20.3847 22.1692 17.6153 22.1692 15.3985 20.8391L14 20L12.6015 20.8391C10.3847 22.1692 7.61531 22.1692 5.39853 20.8391L4 20V12Z\" fill=\"none\" stroke=\"#bfcbd9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M8 22.4889V44H40V22\" stroke=\"#bfcbd9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M8 11.8222V4H40V12\" stroke=\"#bfcbd9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><rect x=\"19\" y=\"32\" width=\"10\" height=\"12\" fill=\"none\" stroke=\"#bfcbd9\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shop.svg
// module id = hert
// module chunks = 94